import React, { Component } from 'react'

import Input from 'antd/lib/input'
import InputNumber from 'antd/lib/input-number'
import Select from 'antd/lib/select'
import Popover from 'antd/lib/popover'
import Icon from 'antd/lib/icon'
import s from './style.scss'

// TODO: Unit test

const createParamaterForm = (parameters, parentFieldName, fieldTypeClass='transformation', form, isDisabled) => {

    let textSnippetsAndFields = [];

    parameters.forEach((p, i) => {

        textSnippetsAndFields.push(
            <span key={i + 'type'}>
              {form.getFieldDecorator(`${parentFieldName}.type`, {
                  initialValue: p.type
              })(<Input type={'hidden'} />)}
            </span>
        )

        if ('label' in p) {
            textSnippetsAndFields.push(p.label + ' ')
        }

        let templateStringSlitted = p.text.split(/\{\{|\}\}/g)

        let length = templateStringSlitted.length
        for (let i = 0; i < length; i++) {

            // Push text snippets
            if (i % 2 === 0) {
                textSnippetsAndFields.push(templateStringSlitted[i])
            }

            // Push form elements
            if (i % 2 !== 0) {

                // create form element

                let dataSeriesParamName = templateStringSlitted[i]

                let fieldProps = p.parameters[dataSeriesParamName]

                let fieldName = ''

                if (fieldTypeClass === 'dataSeriesParam') {
                    fieldName = `${parentFieldName}.${dataSeriesParamName}`
                } else if (fieldTypeClass === 'transformation') {
                    fieldName = `${parentFieldName}.${p.type}.${dataSeriesParamName}`
                } else {
                    throw new Error(`Invalid field type class ${fieldTypeClass}`)
                }

                switch (fieldProps.type) {
                    case "text":
                        textSnippetsAndFields.push(
                            <span key={i}>
                              {form.getFieldDecorator(fieldName, {
                                  initialValue: fieldProps.defaultValue ?
                                    fieldProps.defaultValue : null
                              })(
                                <Input
                                    key={i}
                                    size={fieldProps.size ? fieldProps.size : 5}
                                    placeholder={fieldProps.placeholder ?
                                        fieldProps.placeholder : ""}
                                    disabled={isDisabled}
                                />
                              )}
                            </span>
                        );

                        break

                    case "number":
                        textSnippetsAndFields.push(
                            <span key={i}>
                              {form.getFieldDecorator(fieldName, {
                                  initialValue: fieldProps.defaultValue ?
                                    parseFloat(fieldProps.defaultValue) : null
                              })(
                                <InputNumber
                                    key={i}
                                    size={fieldProps.size ? fieldProps.size : 5}
                                    placeholder={fieldProps.placeholder ?
                                    fieldProps.placeholder : ""}
                                    disabled={isDisabled}
                                />
                              )}
                            </span>
                        );

                        break

                    case "select":
                        textSnippetsAndFields.push(
                            <span key={i}>
                              {form.getFieldDecorator(fieldName, {
                                  initialValue: fieldProps.defaultValue
                              })(
                                  <Select style={{width: 200}} disabled={isDisabled}>
                                      {fieldProps.options.map((option, i) =>
                                          <Select.Option key={i} value={option.value}>
                                            {option.label}
                                        </Select.Option>
                                      )}
                                  </Select>
                              )}
                            </span>
                        )
                        break

                    case "dataQuery":
                    // creation of the cascader is handled elsewhere
                    break

                    default:
                        console.error(`No such field type: ${fieldProps.type}`)
                }
            }
        }

        if('help' in p) {
            textSnippetsAndFields.push(
                <span key={'help' + i}>
                    <Popover
                        placement="topLeft"
                        arrowPointAtCenter={true}
                        title={'About this transformation'}
                        content={p.help}
                        trigger="click"
                        overlayStyle={{'width': '250px',}}
                    >
                        <Icon type="question-circle-o" className={s.helpIcon}/>
                    </Popover>
                </span>
            )
        }
    
        textSnippetsAndFields.push(<br key={i}/>)

    })

    return textSnippetsAndFields
}

export default createParamaterForm